<script setup></script>

<template>
  <PageLayout>
    <template #header>
      <div></div>
    </template>
    <VBusHelper
      :emitOnMounted="$constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESH"
    />
    <div class="py-4"></div>
    <div class="py-2 text-2xl font-bold px-4">Transactions</div>
    <TransactionsLoadingError
      @refresh="
        () => $bus.emit($constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESH)
      "
      v-if="$stores.transactions?.state?.list_all?.error"
    >
      <template #errorDescription>
        {{ $stores.transactions?.state?.list_all?.error }}
      </template>
    </TransactionsLoadingError>
    <div
      v-else-if="$stores.transactions?.state?.list_all?.list.length"
      class="px-4"
    >
      <div
        v-for="(trx, index) in $stores.transactions?.state?.list_all?.list"
        :key="trx.id"
        :class="{ 'border-b border-slate-100': index < $stores.transactions?.state?.list_all?.list.length - 1 }"
      >
        <TransactionItem
          @click="$bus.emit($constants.EVENTS.TRANSACTIONS.DETAIL.SHOW, trx)"
          :item="trx"
        />
      </div>
    </div>
    <div
      v-else-if="$stores.transactions?.state?.list_all?.loading"
      class="px-4"
    >
      <div
        v-for="i in 5"
        :key="i"
        :class="{ 'border-b border-slate-100': i < 5 }"
      >
        <TransactionItem :item="{}" />
      </div>
    </div>
    <EmptyTransactions
      @refresh="
        () => $bus.emit($constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESH)
      "
      v-else
    />
  </PageLayout>
</template>
